// iter87.259 — Official La Liga club brand color pairs (2026/27
// season). Keyed by the SHORT form our `scheduled_matches.home_label`
// / `.away_label` fields actually store (verified against live DB
// rows — e.g. "Barcelona" not "FC Barcelona", "Atletico Madrid" not
// "Atlético Madrid", "Alaves" not "Deportivo Alavés", "Malaga" not
// "Málaga CF", "Deportivo La Coruna" not "RC Deportivo La Coruña",
// "Racing Santander" not "Real Racing Club"). Long-form official names
// included as aliases too. Accented characters normalized to their
// plain-ASCII DB form.
export const LA_LIGA_TEAM_COLORS = {
    "Athletic Club": ["#D01B1A", "#FFFFFF"],
    "Atletico Madrid": ["#CB3524", "#FFFFFF"],
    "Atlético Madrid": ["#CB3524", "#FFFFFF"],
    "Osasuna": ["#D91A2A", "#0A1128"],
    "CA Osasuna": ["#D91A2A", "#0A1128"],
    "Alaves": ["#005DAA", "#FFFFFF"],
    "Deportivo Alaves": ["#005DAA", "#FFFFFF"],
    "Deportivo Alavés": ["#005DAA", "#FFFFFF"],
    "Elche": ["#008751", "#FFFFFF"],
    "Elche CF": ["#008751", "#FFFFFF"],
    "Barcelona": ["#004D98", "#A50044"],
    "FC Barcelona": ["#004D98", "#A50044"],
    "Getafe": ["#00509E", "#FFFFFF"],
    "Getafe CF": ["#00509E", "#FFFFFF"],
    "Levante": ["#001C54", "#C8102E"],
    "Levante UD": ["#001C54", "#C8102E"],
    "Malaga": ["#6CABDD", "#FFFFFF"],
    "Málaga CF": ["#6CABDD", "#FFFFFF"],
    "Rayo Vallecano": ["#FFFFFF", "#E30613"],
    "Celta Vigo": ["#87CEEB", "#FFFFFF"],
    "RC Celta de Vigo": ["#87CEEB", "#FFFFFF"],
    "Deportivo La Coruna": ["#00529B", "#FFFFFF"],
    "RC Deportivo La Coruña": ["#00529B", "#FFFFFF"],
    "Espanyol": ["#0072CE", "#FFFFFF"],
    "RCD Espanyol": ["#0072CE", "#FFFFFF"],
    "Real Betis": ["#009640", "#FFFFFF"],
    "Real Madrid": ["#FFFFFF", "#FEBE10"],
    "Racing Santander": ["#008539", "#FFFFFF"],
    "Real Racing Club": ["#008539", "#FFFFFF"],
    "Real Sociedad": ["#0051A2", "#FFFFFF"],
    "Sevilla": ["#FFFFFF", "#D4001A"],
    "Sevilla FC": ["#FFFFFF", "#D4001A"],
    "Valencia": ["#FFFFFF", "#000000"],
    "Valencia CF": ["#FFFFFF", "#000000"],
    "Villarreal": ["#FFE600", "#00529B"],
    "Villarreal CF": ["#FFE600", "#00529B"],
};
